import { Button, Divider, Flex, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { useModalForm } from "../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../layouts/MainPagetitle";
import OpsLeadCards from "./OpsLeadCards";
import OpsLeadsSearch from "./OpsLeadsSearch/OpsLeadsSearch";

const OpsLeads = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
    order_by: "updatedAt",
    order_direction: "DESC",
  });

  // ---------------------------------------------------------------
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [editData, setEditData] = useState([]);
  const initialColumnsRef = useRef([
    {
      dataIndex: "lead_name",
      title: "Customer Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "source",
      title: "Source",
      render: (text, record) => {
        return <>{text?.toTitleCase() || "-"}</>;
      },
    },
    {
      dataIndex: "assignedEmployee",
      title: "Assigned To",
      render: (_, record) => record?.assignedEmployee?.full_name || "-",
    },
    {
      dataIndex: "assigned_on",
      title: "Assigned On",
      render: (text) =>
        text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-",
    },
    {
      dataIndex: "assignedEmployee",
      title: "Opps Mobile No.",
      render: (_, record) => record?.assignedEmployee?.mobile_number || "-",
    },
    {
      dataIndex: "status",
      title: "Lead Status",
      render: (text, record) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
    {
      dataIndex: "opsApplications",
      title: "Sales Status",
      render: (text, record) => {
        let status = record?.opsApplications[0]?.application_status;
        if (status) {
          return (
            <AppTag color={_enum.STATUS_COLOR_MAP[status?.toLowerCase()]}>
              {status?.toTitleCase() || "-"}
            </AppTag>
          );
        } else {
          return "-";
        }
      },
    },
  ]);
  const [rowcount, setRowcount] = useState(0);
  const [columns, setColumns] = useState(initialColumnsRef.current);
  const [cardData, setCardData] = useState({});

  const logColumns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      render: (text) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      title: "Lead Status",
      dataIndex: "status",
      render: (text) => {
        return (
          <AppTag size="sm" color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
    { title: "Updated By", dataIndex: "updated_by_id" },
    { title: "Remarks", dataIndex: "remarks" },
  ];

  const modalConfigs = {
    leadsInfo: [
      {
        label: "Name",
        name: "lead_name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
      },
      {
        label: "Mobile No.",
        name: "mobile_number",
        type: "text",
        placeholder: "Please Enter",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        label: "Email ID",
        name: "email_address",
        type: "email",
        placeholder: "Please Enter",
        rules: _enum.EMAIL_RULE,
        required: true,
      },
      {
        label: "Source",
        name: "source",
        type: "select",
        options: _enum.SOURCES,
        placeholder: "Please Enter",
        required: true,
      },
      {
        label: "Req. Loan Amt.",
        name: "loan_amount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        name: "location",
        label: "Work Location",
        type: "select",
        options: [],
        fetchKey: "location_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetMasterLocations();
          if (data) return data?.options("location_name");
          return [];
        },
      },
      {
        name: "state",
        label: "State",
        type: "text",
        readOnly: true,
      },
      {
        name: "city",
        label: "City",
        type: "text",
        readOnly: true,
      },
      {
        label: "Lead Status",
        name: "status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS,
        placeholder: "Please Enter",
        required: true,
      },
      {
        label: "Remarks",
        name: "remarks",
        type: "textarea",
        colspan: 24,
      },
    ],
  };

  const dependencies = {
    location: async (value) => {
      if (value) {
        const res = await props.apis.apiGetLocationByName({
          location_name: value,
        });
        if (res) {
          return {
            valueUpdates: {
              state: res?.state,
              city: res?.city,
            },
          };
        }
      }
      return {};
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  // ----------------- API helpers -----------------

  const getLeads = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "page",
        "limit",
        "order_by",
        "order_direction",
      ]);
      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    props.apis
      .apiGetLeads({ ...payload, view_type: "ASSIGNED_BY_ME" })
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const downloadExcel = async () => {
    let payload = {};
    props.apis.apiExportLeadsAssignedByMe(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Leads_Assigned_By_Me_Details.xlsx`);
        link.click();
      }
    });
  };

  // ----------------- actions -----------------
  const view = async (record) => {
    const data = await props.apis.apiGetLeadsById({
      lead_id: record.lead_id,
    });
    setEditData(data);
    openModal("leadsInfo", "view", "View Lead", { ...data });
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getLeads(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getLeads(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    console.log({ onPageChange: pageData });
    setSearch({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  // ----------------- lifecycle -----------------

  useEffect(() => {
    props.apis.apiGetDashboardMoke().then((res) => {
      setCardData(res);
    });

    getLeads();
  }, []);

  // ---------------------------------------------------------------
  props.$setNode({
    props,
    search,
    rowcount,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Assigned to Ops"
        pageTitle={"Assigned to Ops"}
        parentTitle={"Home"}
        pageIcon={imagepaths.FileIconBlueActive}
      />
      <div className="container-fluid">
        <OpsLeadCards />
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <Flex
                  gap="middle"
                  align="center"
                  justify="end"
                  className="px-3"
                >
                  <Space size="small" split={<Divider type="vertical" />} wrap>
                    <AppButton
                      variant="excel"
                      onClick={(e) => downloadExcel(e)}
                    >
                      Download Excel
                    </AppButton>
                    <OpsLeadsSearch
                      onSearch={(...arg) => onSearch(...arg)}
                      openModal={openModal}
                    />
                  </Space>
                </Flex>

                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  viewAction={(e) => view(e)}
                  editable={false}
                  deletable={false}
                  loading={isFetching}
                ></AppTable>

                <AppFormModal
                  form={appform}
                  title={modalState.title}
                  open={modalState.open}
                  onValuesChange={handleValuesChange}
                  onClose={closeModal}
                  fields={modalState.fields}
                  mode={modalState.mode}
                  // extraSections={[
                  //   {
                  //     title: "Logs",
                  //     type: "table",
                  //     data: editData?.logs,
                  //     columns: logColumns,
                  //     showIn: ["view"], // only show in view mode
                  //   },
                  // ]}
                  persona={props?.$store?.user?.role}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(OpsLeads);
